import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { sv } from "./locales/sv";
import { en } from "./locales/en";
import { no } from "./locales/no";
import { da } from "./locales/da";
import { fi } from "./locales/fi";

i18n.use(initReactI18next).init({
  resources: {
    sv: { translation: sv },
    en: { translation: en },
    no: { translation: no },
    da: { translation: da },
    fi: { translation: fi },
  },
  lng: "sv",
  fallbackLng: "sv",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
